export default "__VITE_ASSET__D8BOk3$d__"